import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  getIdThunk,
  getTextThunk,
  mintNftThunk,
  cacheNftThunk,
} from './editorThunk';
import utils from '../../utils/dataUtils';

const initialState = {
  id: null,
  title: '',
  text: '',
  lastSaved: Date.now(),
  tokenURI: '',
};

const saveInterval = 10000;

export const getId = createAsyncThunk('editor/id', getIdThunk);
export const getText = createAsyncThunk('editor/text', getTextThunk);
export const mintNft = createAsyncThunk('editor/mint', mintNftThunk);
export const cacheNft = createAsyncThunk('editor/cache', cacheNftThunk);

const socketSlice = createSlice({
  name: 'editor',
  initialState,
  reducers: {
    setId: (state, { payload }) => {
      const { id } = payload;
      state.id = id;
    },
    updateTitle: (state, { payload }) => {
      const { title } = payload;
      state.title = title;
    },
    updateText: (state, { payload }) => {
      const { text } = payload;
      state.text = text;
    },
    putText: (state, { payload }) => {
      const { account, force } = payload;
      if (Date.now() - state.lastSaved >= saveInterval || force) {
        utils.putText(state.id, account, state.title, state.text);
        state.lastSaved = Date.now();
      }
    },
  },
  extraReducers: {
    [getId.pending]: (state) => {
      state.isLoading = true;
    },
    [getId.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      const { id } = payload;
      state.id = id;
      state.title = '';
      state.text = '';
    },
    [getId.rejected]: (state) => {
      state.isLoading = false;
    },
    [getText.pending]: (state) => {
      state.isLoading = true;
    },
    [getText.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      if (payload.text) {
        const { owner, title, text } = payload.text;
        state.owner = owner;
        state.title = title;
        state.text = text;
      }
    },
    [getText.rejected]: (state) => {
      state.isLoading = false;
    },
    [mintNft.pending]: (state) => {
      state.isLoading = true;
    },
    [mintNft.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      const { tokenURI } = payload;
      state.tokenURI = tokenURI;
    },
    [mintNft.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { setId, updateTitle, updateText, putText } = socketSlice.actions;
export default socketSlice.reducer;
